export default [
  {
    value: 'CAN_VISIT_IFORM_PAGE',
    label: 'Can visit IForm',
    category: 'IFORM',
  },
];
